import React from 'react';
import { Input, Form, Col, Row } from 'antd';
import './ElementContainer.css';

const FragmentComponent = ({ constantFragment, variableFragment, attachmentOrder }) => {
  return (
    <div className="element-container">
      <Form layout="vertical">
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Constant Fragment">
              <Input.TextArea
                id="constantFragment"
                placeholder="SMILES of constant fragment"
                value={constantFragment}
                rows={4}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Variable Fragment">
              <Input.TextArea
                id="variableFragment"
                placeholder="SMILES of variable fragment"
                value={variableFragment}
                rows={4}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Attachment Order">
              <Input.TextArea
                id="attachmentOrder"
                placeholder="Attachment Order of SMILES"
                value={attachmentOrder}
                rows={4}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default FragmentComponent;

